/** Returns true when auth microservice rejected login with no Unity access (IQVIACBEXU-9864 / 10030). */
export function isAuthAccessDeniedError(error: unknown): boolean {
  if (!error || typeof error !== "object") {
    return false;
  }
  const candidate = error as { status?: number; data?: { reason?: string } };
  return candidate.status === 403 && candidate.data?.reason === "ACCESS_DENIED";
}
